import styled from "styled-components";

const Err = () => {
  return (
    <ErrorDiv>
      <h1>Page 404</h1>
    </ErrorDiv>
  );
};
const ErrorDiv = styled.div`
  background-color: var(--black);
  width: 100%;
  height: 95%;
  display: flex;
  justify-content: center;
  align-items: center;
  h1 {
    font-size: 150px;
  }
  @media screen and (max-width: 991px) {
    /* start of medium tablet and phone styles */
    h1 {
      padding: 0 10px;
      font-size: 70px;
    }
  }
`;
export default Err;
